import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { performLogout } from "lib/userUtils";

import StotlesLogoText from "../../../../assets/images/stotles_logo_and_typeface.svg";

type HorizontalNavProps = {
  disableLogoNav?: boolean;
};

// Used only for some auth pages where we just want to show the logo + a few action buttons
const HorizontalNav = ({ disableLogoNav = false }: HorizontalNavProps) => {
  const { data: currentUser } = useCurrentUser();

  return (
    <Header>
      {disableLogoNav ? (
        <Logo src={StotlesLogoText} alt="Stotles Logo" />
      ) : (
        <LogoWrapper href="https://www.stotles.com">
          <Logo src={StotlesLogoText} alt="Stotles Logo" />
        </LogoWrapper>
      )}
      {currentUser && (
        <Button buttonType="tertiary" onClick={performLogout}>
          Log out
        </Button>
      )}
    </Header>
  );
};

const Header = styled.header({
  display: "flex",
  justifyContent: "space-between",
  padding: "16px 32px",
  boxShadow: "0px -1px 0px 0px rgba(37, 37, 37, 0.1) inset",
});

const LogoWrapper = styled.a({
  display: "flex",
});

const Logo = styled.img({
  height: 32,
});

export default HorizontalNav;
